export async function sendDataAPI(
	// biome-ignore lint/suspicious/noExplicitAny: callers pass arbitrary query params
	{ jwtToken, ...params }: { jwtToken: string; [key: string]: any },
	url: string,
	method: string,
	body: string | FormData | undefined = undefined,
	contentType: string = 'application/json',
) {
	const data = {
		...params,
	};
	const queryString = new URLSearchParams(data).toString();
	const apiUrl = queryString ? `${url}?${queryString}` : url;

	const headers: Record<string, string> = {
		Authorization: `Bearer ${jwtToken}`,
	};

	if (contentType !== 'multipart/form-data') {
		headers['Content-Type'] = contentType;
	}

	try {
		const response = await fetch(apiUrl, {
			headers: headers,
			method: method,
			body: body,
		});

		if (!response.ok) {
			const errorData = await response.json();
			throw new Error(errorData.message || `API error, please try again (code: ${response.status})`);
		}

		return response;
	} catch (error) {
		const errorMessage = {
			message: (error as Error).message,
		};

		return new Response(JSON.stringify(errorMessage), {
			status: 500,
			statusText: 'Internal Server Error',
			headers: { 'Content-Type': 'application/json' },
		});
	}
}
